{
    "ClientConfigurationModal_AddTitle": "Clientkonfiguration hinzufügen",
    "ClientConfigurationModal_ChangeTitle": "Client-Konfiguration ändern",
    "ClientConfigurationModal_Footer_Actions_Submit": "Einreichen",
    "ClientConfigurationModal_Footer_Actions_Cancel": "Stornieren",
    "ClientConfigurationModal_Footer_Actions_Help": "Helfen",
    "ClientConfigurationModal_Tabs_Details": "Details",
    "ClientConfigurationModal_Tabs_Scope": "Umfang",
    "ClientConfigurationModal_Tabs_Policy": "Politik",
    "ClientConfigurationModal_Tabs_Settings": "Einstellungen",
    "ClientConfigurationModal_Tab_Details_Description": "Beschreibung",
    "ClientConfigurationModal_Tab_Details_Description_Required": "Beschreibung ist erforderlich",
    "ClientConfigurationModal_Tab_Details_ID": "AUSWEIS",
    "ClientConfigurationModal_Tab_Details_ID_Placeholder": "[Automatisch zugewiesen]",
    "ClientConfigurationModal_Tab_Details_Override": "Alle Clientkonfigurationen überschreiben",
    "ClientConfigurationModal_Tab_Scope_CME": "CME",
    "ClientConfigurationModal_Tab_Scope_Telsys": "Telefonieserver",
    "ClientConfigurationModal_Tab_Scope_Telsys_Required": "Telefonieserver ist erforderlich",
    "ClientConfigurationModal_Tab_Scope_Partition": "Partition",
    "ClientConfigurationModal_Tab_Scope_Device": "Gerät",
    "ClientConfigurationModal_Tab_Scope_FilterRecursive": "Rekursiv filtern",
    "ClientConfigurationModal_Tab_Policy_PolicyItem": "Richtlinienelement",
    "ClientConfigurationModal_Tab_Policy_DefaultValue": "Standardwert",
    "ClientConfigurationModal_Tab_Policy_ActualValue": "Tatsächlicher Wert",
    "ClientConfigurationModal_Policy_core": {
        "showUseConfigurationWindow": "Core - Kann Konfigurationsfenster anzeigen\/verwenden",
        "permittedToLogin": "Core - Anmeldung erlaubt"
    },
    "ClientConfigurationModal_Policy_configOptions": {
        "useLocalhostAPI": "Konfiguration – Localhost-API verwenden",
        "canConfigureCustomEvents": "Konfiguration - Benutzerdefinierte Ereignisse konfigurieren"
    },
    "ClientConfigurationModal_Policy_menuOptions": {
        "canShowAddressBook": "Menü - Adressbuch"
    },
    "ClientConfigurationModal_Policy_crm": {
        "canAddNewContacts": "Kann neue Kontakte zu CRMs hinzufügen (über Assistent)"
    },
    "ClientConfigurationModal_Tab_Settings_SettingsItem": "Einstellungsoption",
    "ClientConfigurationModal_Tab_Settings_DefaultValue": "Standardwert",
    "ClientConfigurationModal_Tab_Settings_ActualValue": "Tatsächlicher Wert",
    "ClientConfigurationModal_Settings_interface": {
        "showCallNotificationPreview": "Schnittstelle - Anrufbenachrichtigungsvorschau anzeigen",
        "showMissedCallPreview": "Schnittstelle - Vorschau verpasster Anrufe anzeigen",
        "connectedHideDelay": "Schnittstelle - Verbundene Ausblendverzögerung",
        "previewWindowAlwaysOnTop": "Schnittstelle - Vorschaufenster immer im Vordergrund",
        "showContactInEditMode": "Schnittstelle - Kontakt im Bearbeitungsmodus anzeigen",
        "applicationLoadAtWindowsStartup": "Schnittstelle - Anwendungsladen beim Windows-Start"
    },
    "ClientConfigurationModal_Settings_hotkey": {
        "makeCall": "Hotkey - Anrufen"
    },
    "ClientConfigurationModal_Settings_dialing": {
        "clipboardDialing": "Wählen - Zwischenablage wählen",
        "focusDialing": "Wählen - Fokuswählen",
        "screenDialing": "Wählen – Bildschirmwahl"
    },
    "ClientConfigurationModal_Settings_logPage": {
        "sendAnonymouseStats": "Protokollseite – Anonyme Statistiken senden",
        "loggingLevel": "Protokollseite – Protokollierungsebene",
        "sendAnonymousStats": "Protokollseite – Anonyme Statistiken senden"
    },
    "ClientConfigurationModal_Settings_version": {
        "checkForUpdates": "Version – Nach Updates suchen und herunterladen"
    },
    "NAME": "ClientConfigurationModalLanguage",
    "ClientConfigurationModal_Error_NotFound": "Clientkonfiguration nicht gefunden oder nicht vorhanden"
}